/**
 * @file 初期モーダル
 *
 */
'use strict';
import Common from '../../Utils/Common';
import Modal from '../../Libs/bootstrap/modal';

/**
 * @classname InitialModal
 * @classdesc 初期モーダル
 */
export default class InitialModal {
	/**
	 * @constructor
	 * @param {jQuery} $e - 該当する jQuery オブジェクト
	 */
	constructor($e, controller) {
		console.log('InitialModal.constructor');
		let complete = localStorage.getItem('init') || null;
		const params = Common.getParam();
		console.log(params);
		if(params['city_code'] && params['city_name']) {
		    complete = true;
            window.localStorage.setItem('init', 'complete');
            const childBirthdayYY = params['child_birthday'].substr(0,4);
            const childBirthdayMM = params['child_birthday'].substr(4,2);
            const childBirthdayDD = params['child_birthday'].substr(6,2);
            controller.setPassportInfo2(decodeURI(params['child_name']), params['city_code'], decodeURI(params['city_name']), childBirthdayYY, childBirthdayMM, childBirthdayDD)
        }
		controller._$modal = new Modal(document.getElementById('initialModal'), {
			'backdrop': 'static'
		})
		console.log(complete);
		if(!complete) {
			controller._$modal.show();
		}
	};
}
